<template>
  <div class="container">
    <div class="wrapper">
      <div class="title">习讯云校企合作平台信息服务协议</div>
      <div class="detail">
        <div>&nbsp;&nbsp;&nbsp;&nbsp;甲方即将购买的信息服务的提供者均为万博云信（北京）教育科技有限公司（以下简称“万博云信”）。习讯云校企合作平台信息服务协议（以下简称“本协议”）是甲方与万博云信就甲方甲方购买的信息服务及其包含的各项服务所订立的相关权利义务规范。甲方继续购买信息服务，即表示接受并同意本协议的所有条款，并同意以数据电文形式订立本协议。万博云信作为信息服务的提供者，将依据本协议为甲方提供服务。如甲方不理解本协议的任何条款，请致电万博云信客服热线189 1165 6408，万博云信的客服人员会为甲方解释，如果甲方不愿接受本协议条款的，请停止购买行为。</div>
        <div>&nbsp;&nbsp;&nbsp;&nbsp;经甲、乙双方友好协商，在平等、自愿的基础上，达成以下协议内容：</div>
        <div style="font-weight: bold;">一、信息服务内容及金额</div>
        <div>1. 乙方拥有“习讯云校企合作服务平台”（以下简称“乙方平台”或“平台”），且平台已被学校采用，可向甲方提供校企合作会员认证和在线招聘服务。</div>
        <div>2. 甲方愿意接受乙方的平台服务，并成为乙方平台服务学校的单位会员。</div>
        <div>3. 服务费用：甲方购买信息服务时实际支付的金额即本协议项下相关服务的服务费金额，乙方收到甲方款项后3个工作日内为甲方开通账号。</div>
        <div>4. 乙方平台的单位会员资格具有时效性，甲方根据自己需要选购“会员时效”。</div>
        <div style="font-weight: bold;">二. 在会员有效期内，甲方享有以下权益：</div>
        <div>A. 可以随时联系已认证通过的学校，向其发布自己单位的校企合作需求。</div>
        <div>B. 可以随时修改自己单位的招聘信息。</div>
        <div>C. 可以查看向自己求职的已认证的学校学生详细信息。</div>
        <div style="font-weight: bold;">三. 甲方发布招聘信息时的禁止事项</div>
        <div>A. 禁止发布其它单位的招聘信息。</div>
        <div>B. 禁止重复发布招聘信息。如招聘信息有变化，可在平台执行修改。</div>
        <div style="font-weight: bold;">四.其他事项</div>
        <div>1. 甲方如果违反禁止事项，乙方有权在不通知的情形下暂停甲方会员资格。</div>
        <div>2. 会员服务不包括广告位服务。甲方如有广告位需求，可以另行购买。</div>
        <div>3. 免责声明：因平台空间、域名解析、系统调整而导致的暂时故障，乙方享有免责权。</div>
        <div>4. 本协议一经签署立即生效，有效期与“甲方购买的会员时效”一致。</div>
        <div>5. 本协议壹式贰份，双方各执壹份，每份协议具有同等法律效力。</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      e_name: null,
      schoolName: null,
      fee: null
    };
  },
  mounted() {
    // this.getInfo();
    // this.getSchoolName();
    // this.getFee()
  },
  methods: {
    async getInfo() {
      let res = await this.$api.info.get();
      if (res.code === 0) {
        if (res.data.length === 0) {
          return;
        }
        let item = res.data[0];
        this.e_name = item.e_name;
      }
    },
    async getSchoolName() {
      let res = await this.$api.school.getSchool(1, 100);
      if (res.code === 0) {
        for (const item of res.data.items) {
          if (item.id == this.$route.query.schoolId) {
            // console.log(item.fdName)
            this.schoolName = item.fdName;
          }
        }
      }
    },
    async getFee() {
      let res = await this.$api.pay.getSchoolPayInfo(
        this.$route.query.relationId
      );
      if (res.code === 0) {
        this.fee = res.data.fee;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  background: #f1f4f6;
  padding-top: 20px;
  .wrapper {
    width: 90vw;
    margin: 0 auto;
    background: #fff;
    .title {
      background: #6aa2e4;
      color: #fff;
      font-size: 20px;
      text-align: center;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      padding: 10px 15px;
    }
    .detail {
      padding: 15px;
      line-height: 30px;
    }
  }
}
</style>

